import { STATUS } from '../../constants/commonConstants';
export const personalInformationInitialStore = {
  commonVarsStatus: STATUS.RESOLVED,
  dealerVarsStatus: STATUS.RESOLVED,
  status: STATUS.RESOLVED
};
